import {
  CircularProgress as MUICircularProgress,
  CircularProgressProps,
} from '@mui/material';

export { type CircularProgressProps } from '@mui/material';

export function CircularProgress(props: CircularProgressProps) {
  return <MUICircularProgress {...props} />;
}
